<button
  *ngIf="visible"
  mat-icon-button
  matTooltip="{{ 'debugPanel.title' | t }}"
  matTooltipPosition="below"
  (click)="onClick()"
>
  <sn-icon fontIcon="fa-bug" fontSet="fal"></sn-icon>
</button>
